import { render, staticRenderFns } from "./LMorseClickInput.vue?vue&type=template&id=134ae6fe&scoped=true"
import script from "./LMorseClickInput.vue?vue&type=script&lang=js"
export * from "./LMorseClickInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134ae6fe",
  null
  
)

export default component.exports